/* eslint-disable */
export default {
  schedule: 'Besprechung planen',
  prompt:
    'Bitte autorisieren Sie RingCentral für den Zugriff auf Ihre Kontoinformationen.',
  saveAsDefault: 'Als Standard speichern',
} as const;

// @key: @#@"schedule"@#@ @source: @#@"Schedule Meeting"@#@
// @key: @#@"prompt"@#@ @source: @#@"Please authorize RingCentral to access your account information."@#@
// @key: @#@"saveAsDefault"@#@ @source: @#@"Save as default"@#@
